function WHCreateCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    var expires = "; expires=" + date.toGMTString();
	document.cookie = name+"="+value+expires+"; path=/";
}
function WHReadCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

window.onload = WHCheckCookies();

function getThemeColor(){
    return 'rgb(255,255,255)';
    var m = document.querySelector('meta[name=theme-color]');
    var themeColor = m.getAttribute('content');
    return themeColor || '#fff';
}
function WHCheckCookies() {
    if(WHReadCookie('cookies_accepted') != 'T') {
        var message_container = document.createElement('div');
        message_container.id = 'cookies-message-container';
        var html_code = '<div id="cookies-message" style="padding: 10px 0px; font-size: 14px; line-height: 20px; text-align: center; color: white; position: fixed; bottom: 0px; background:rgba(0,0,0,0.7); width: 100%; z-index: 999;">Ta strona używa ciasteczek (cookies), dzięki którym nasz serwis może działać lepiej. <a href="http://wszystkoociasteczkach.pl" rel="nofollow" target="_blank" style="color:'+getThemeColor()+'; text-decoration: underline;padding-right:5px;">Dowiedz się więcej</a><a href="javascript:window.WHCloseCookiesWindow();" class="" style="margin-bottom: 0; margin-left:10px; padding: 5px 10px;" id="accept-cookies-checkbox" name="accept-cookies" >&nbsp;Rozumiem</a></div>';
        if(document.documentElement.lang == "en")
            html_code = '<div id="cookies-message" style="padding: 10px 0px; font-size: 14px; line-height: 20px; text-align: center; color: white; position: fixed; bottom: 0px; background:rgba(0,0,0,0.7); width: 100%; z-index: 999;">This Website uses cookies to improve the quality of service. <a href="http://www.allaboutcookies.org/" rel="nofollow" target="_blank" style="color:'+getThemeColor()+'; text-decoration: underline;padding-right:5px;">Find out more</a><a href="javascript:window.WHCloseCookiesWindow();" class="" style="margin-bottom: 0; margin-left:10px; padding: 5px 10px;" id="accept-cookies-checkbox" name="accept-cookies" >&nbsp;Agree</a></div>';
        message_container.innerHTML = html_code;
        document.body.appendChild(message_container);
    }
}

window.WHCloseCookiesWindow = function () {
    WHCreateCookie('cookies_accepted', 'T', 365);
    document.getElementById('cookies-message-container').removeChild(document.getElementById('cookies-message'));
}




/** WEBPACK FOOTER **
 ** ./cookie.js
 **/